import React from 'react'
export default class OrderNotes extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    const border = "1px solid #ddd"
    let notes = this.props.order_notes
    let noteLines = []
    for (let order_id in notes) {
      let note = notes[order_id]
      noteLines.push([
        <tr key={`${note.name}`}>
          <td style={{ border: border, padding: "2px 5px 2px 5px" }}>{note.name}</td>
          <td style={{ border: border, padding: "2px 5px 2px 5px" }}>{note.note}</td>
        </tr>
      ])
    }
    return <table style={{ border: border, borderCollapse: "collapse", width: "100%" }}>
      <tbody>
        <tr>
          <th style={{ border: border }}>Order</th>
          <th style={{ border: border }}>Notes</th>
        </tr>
        {noteLines}
      </tbody>
    </table >
  }
}